// extracted by mini-css-extract-plugin
module.exports = {"supportEmail":"style_supportEmail__I47mO","supportEmail__container":"style_supportEmail__container___Kx0C"};